//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iconCustomerService from 'assets/icons/icon-customer-service@3x.png'
import iconKefu from 'assets/icons/icon_kefu1@3x.png'
import iconArrow from 'assets/icons/icon-arrow@3x.png'
import meiqia from '../../utils/meiqia'

export default {
  name: 'QuestionBar',
  props: {
    type: {
      type: String,
      required: true,
    },
    dataId: {
      type: Number,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    iconCustomerService,
    iconArrow,
    iconKefu,
  }),
  methods: {
    chat() {
      meiqia.showPanel()
    },
    gotoQuestionList(event) {
      event.preventDefault()
      const query = {}
      if (this.type === 'route') {
        query.routeId = this.dataId
      } else if (this.type === 'tour') {
        query.tourId = this.dataId
      } else {
        query.matchId = this.dataId
      }
      this.$router.push({
        name: 'question-list',
        query,
      })
    },
  },
  created() {
    meiqia.init()
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/QuestionCell.vue